export var SortOrder;
(function (SortOrder) {
    SortOrder["Ascending"] = "ASC";
    SortOrder["Descending"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=SortOrder.js.map